<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Lotes</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <router-link
            v-if="$can('store', 'plots')"
            :to="{ name: 'PlotCreate' }"
            class="btn base-button btn-neutral btn-sm"
          >
            Nuevo
          </router-link>

          <button
            v-if="campaign || allCampaigns"
            class="btn base-button btn-neutral btn-sm"
            @click="changeCampaign(false)"
            v-text="'Cambiar Campaña'"
          ></button>
          <button
            v-if="!allCampaigns"
            class="btn base-button btn-neutral btn-sm"
            @click="changeCampaign(true)"
            v-text="'Todas las Campaña'"
          ></button>

          <router-link
            v-if="$can('index', 'plots')"
            :to="{ name: 'PlotsListMap' }"
            class="btn base-button btn-neutral btn-sm"
          >
            Ver en mapa
          </router-link>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="!campaign && !allCampaigns" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija la campaña para listar los lotes</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="campaign || allCampaigns" class="row">
        <div class="col">
          <plots-table :filter-campaign="campaign" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import PlotsTable from './List/PlotsTable';
import CurrentCampaign from '@/mixins/currentCampaignMixin';

export default {
  components: {
    PlotsTable,
    RouteBreadCrumb,
    CampaignSelect,
  },

  mixins: [CurrentCampaign],
  methods: {
    changeCampaign(showAll) {
      this.campaign = null;
      this.$store.dispatch('navigation/showAllCampaigns', showAll);
    },
  },
};
</script>
